import {
  getReq,
  postReq,
  deleteSendReq,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'

const baseUrl = process.env.BASE_URL

const state = {
  userName: '',
  showImg: false,
  isLoggedin: false,
  refresh: false,
  imgSrc: ''
}

const getters = {
  isLoggedin: (state) => {
    return localStorage.getItem('token') || state.isLoggedin
  }
}

const actions = {
  async login({
    commit,
    state,
    dispatch
  }, {postData, codeParam}) {
    const responseData = await postReq(END_POINTS.LOGIN, {data: postData, headerCodeMap: await getHeaderCodeMap(codeParam)})
    if (responseData.success) {
      commit('updateShowImg', false)
      commit('setLoginUser', { ...responseData.data })
    } else {
      if (postData.username) {
        dispatch('checkIsUseCaptchaLogin', { postData })
      }
    }

    return responseData
  },
  async getUserProfile({
    commit,
    state,
    dispatch
  }) {
    const responseData = await getReq(END_POINTS.GET_USER_PROFILE, {})
    if (responseData.success) {
      commit('updateShowImg', false)
      commit('setLoginUser', { ...responseData.data })
    }

    return responseData
  },
  async logout({
    commit,
    state,
    dispatch
  }, {codeParam}) {
    const responseData = await deleteSendReq(END_POINTS.LOGOUT, {headerCodeMap: await getHeaderCodeMap(codeParam)})
    console.debug('logout-resp:', responseData)
    commit('removeLoginUser')
  },
  async init({commit}) {
    const responseData = await getReq(END_POINTS.TOKEN_EXPIRE, {})

    let isLoggedin

    if (responseData.success) {
      commit('initUser')
      isLoggedin = true
    } else {
      commit('removeLoginUser')

      isLoggedin = false
    }

    return isLoggedin
  },
  async checkLoginStatus({
    state,
    commit
  }) {
    let responseData = await getReq(END_POINTS.TOKEN_EXPIRE, {})
    return responseData
  },
  async checkIsUseCaptchaLogin({
    state,
    dispatch,
    commit
  }, {postData, codeParam}) {
    const responseData = await getReq(END_POINTS.CAPTCHA + `?action=display&id=${postData.username}`, {headerCodeMap: await getHeaderCodeMap(codeParam)})
    if (responseData.data) {
      commit('updateShowImg', true)
      dispatch('getCaptchaImg', postData)
    }
  },
  async getCaptchaImg({
    state,
    dispatch,
    commit
  }, postData) {
    let rnd = ''
    for (let i = 0; i < 5; i++) {
      rnd += Math.floor(Math.random() * 10)
    }
    commit('updateImgSrc', `${baseUrl}${END_POINTS.CAPTCHA}?action=create&id=${postData.username}&random=${rnd}`)
  }
}

const mutations = {
  initUser(state) {
    const token = localStorage.getItem('token')
    const userName = localStorage.getItem('userName')
    if (token && userName) {
      state.userName = userName
      state.isLoggedin = true
    } else {
      state.userName = ''
      state.isLoggedin = false
    }
  },

  setLoginUser(state, {
    id,
    userName,
    familyName,
    firstName,
    token,
    role
  }) {
    localStorage.setItem('token', token)
    localStorage.setItem('userId', id)
    localStorage.setItem('familyName', familyName)
    localStorage.setItem('firstName', firstName)
    localStorage.setItem('role', role)

    state.userName = userName
    state.isLoggedin = true
    // this === $store
    this.state.role = role
  },

  async removeLoginUser(state) {
    console.log('removeLoginUser(state)')
    console.log(localStorage)
    // debugger
    localStorage.removeItem('token')
    localStorage.removeItem('userId')
    localStorage.removeItem('familyName')
    localStorage.removeItem('firstName')
    localStorage.removeItem('role')

    state.userName = ''
    state.isLoggedin = false
    // this === $store
    this.state.role = ''
    this.commit('updateGlobalCompId', '')
    this.commit('systemAuthManage/updateCurrentSubsysKey', '')
  },
  updateShowImg(state, showImg) {
    state.showImg = showImg
  },
  updateImgSrc(state, imgSrc) {
    state.imgSrc = imgSrc
  },
  updateRefresh(state, flag) {
    state.refresh = flag
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login/index.js